"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExampleUsage = exports.MacroWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const HtmlHelper_1 = require("./services/HtmlHelper");
const useSetPaymentModal_1 = require("./hooks/useSetPaymentModal");
const useActions = () => {
    const setPaymentModal = (0, useSetPaymentModal_1.useSetPaymentModal)();
    return {
        openPaymentOptions: () => setPaymentModal(true),
        anotherAction: () => console.log('Another action!'),
    };
};
const actionComponents = {
    openPaymentOptions: ({ displayText, onClick }) => ((0, jsx_runtime_1.jsx)(material_1.Link, { sx: { cursor: 'pointer' }, color: 'inherit', onClick: onClick, children: displayText })),
    anotherAction: ({ displayText, onClick }) => ((0, jsx_runtime_1.jsx)("button", { onClick: onClick, children: displayText })),
};
function getActionComponent(actionName, displayText) {
    const actions = useActions();
    if (actionName in actions) {
        const ActionComponent = actionComponents[actionName];
        const onClick = actions[actionName];
        return ActionComponent ? ((0, jsx_runtime_1.jsx)(ActionComponent, { displayText: displayText, onClick: onClick })) : ((0, jsx_runtime_1.jsxs)("span", { style: { color: 'red' }, children: ["Action ", actionName, " not defined."] }));
    }
    return null;
}
function parseAndRenderContent(text) {
    const macroRegex = /<macro action=([\w]+)>(.*?)<\/macro>/g;
    const parts = [];
    let lastIndex = 0;
    let match;
    while ((match = macroRegex.exec(text)) !== null) {
        const [fullMatch, actionName, displayText] = match;
        const macroStart = match.index;
        if (macroStart > lastIndex) {
            const rawHtml = text.slice(lastIndex, macroStart);
            parts.push((0, jsx_runtime_1.jsx)("span", { dangerouslySetInnerHTML: { __html: (0, HtmlHelper_1.sanitizeHtmlString)(rawHtml) } }, `html-${lastIndex}`));
        }
        const actionComponent = getActionComponent(actionName, displayText);
        if (actionComponent) {
            parts.push(actionComponent);
        }
        else {
            parts.push((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: fullMatch }, `macro-${macroStart}`));
        }
        lastIndex = macroRegex.lastIndex;
    }
    if (lastIndex < text.length) {
        const remainingHtml = text.slice(lastIndex);
        parts.push((0, jsx_runtime_1.jsx)("span", { dangerouslySetInnerHTML: { __html: (0, HtmlHelper_1.sanitizeHtmlString)(remainingHtml) } }, `html-${lastIndex}`));
    }
    return parts;
}
const MacroWrapper = ({ children }) => {
    const renderWithMacros = (node) => {
        if (typeof node === 'string') {
            return parseAndRenderContent(node);
        }
        if (react_1.default.isValidElement(node) && node.props.children) {
            const { children: nodeChildren } = node.props;
            return react_1.default.cloneElement(node, {
                children: renderWithMacros(nodeChildren),
            });
        }
        if (Array.isArray(node)) {
            return node.map((child, index) => ((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: renderWithMacros(child) }, index)));
        }
        return node;
    };
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: renderWithMacros(children) });
};
exports.MacroWrapper = MacroWrapper;
const ExampleUsage = ({ config }) => {
    var _a;
    return ((0, jsx_runtime_1.jsx)(MacroWrapper, { children: (_a = config.features) === null || _a === void 0 ? void 0 : _a.paymentsPanel.details.map((details, index) => ((0, jsx_runtime_1.jsx)(material_1.ListItem, { sx: { py: 0 }, children: (0, jsx_runtime_1.jsx)(material_1.ListItemText, { primary: details.info }) }, index))) }));
};
exports.ExampleUsage = ExampleUsage;
